import { Ilanguages } from "models/utilitiesModel";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { getIdleSelectionTimer } from "../../../../helpers/helpersIndex";
import nextAppt from "../../../../images/apptnext.svg";
import prevAppt from "../../../../images/apptprev.svg";
import {
  IKioskAppointmentDto,
  IKioskModel,
} from "../../../../models/kioskModel";
import {
  appointmentsCheckinRequest,
  idleErrorMessage,
} from "../../../../store/actions";
import "../../Kiosk.css";

const ThemeOneAppointmentsList: React.FC = () => {
  let timer: any = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);
  const audioPath = `assets/audioSpeeches/fp-006.mp3`;
  const pageSize = 3;

  const { t } = useTranslation("translations");
  const dispatch = useDispatch();
  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });
  const appointmentsData: IKioskAppointmentDto[] = useSelector((state: any) => {
    if (state?.kioskReducer?.appointmentsData)
      return (state.kioskReducer as IKioskModel).appointmentsData;
    else return [];
  });
  const emiratesData: any = useSelector(
    (state: any) => (state.kioskReducer as IKioskModel)?.emiratesData
  );
  const nameOfuser =
    language === Ilanguages.ENG
      ? `${emiratesData?.enName?.split(",")?.[0]} ${
          emiratesData?.enName?.split(",")?.[1]
        }`
      : `${emiratesData?.arName?.split(",")?.[0]} ${
          emiratesData?.arName?.split(",")?.[1]
        }`;
  console.log("ThemeOneAppointmentsList =>", language, appointmentsData);
  let pagesCount = Math.ceil(
    (appointmentsData ? appointmentsData.length : 0) / pageSize
  );
  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      const msg = !language
        ? t("Kiosk.sorryRequestFailed")
        : t("Kiosk.sorryRequestFailed-Ar");
      dispatch(idleErrorMessage(msg));
    }, getIdleSelectionTimer() * 1000);

    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [currentPage, dispatch, language, t]);

  // const updatelocalStorage = () => {
  //     const currentTime = new Date().toString();
  //     const tokenData: any = JSON.parse(localStorage.getItem("tokenData") || "{}");
  //     localStorage.setItem("tokenData", JSON.stringify({ ...tokenData, [currentTime]: tokenData?.[currentTime] ? tokenData?.[currentTime] + 1 : 1 }));
  // }

  return (
    <>
      {appointmentsData && appointmentsData.length > 0 && (
        <div className="kiosk-content">
          <audio autoPlay>
            <source type="audio/wav" src={audioPath} />
          </audio>
          {console.log("the_udpate_timer", timer)}
          <div
            className="content-sec"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            {/* appointment section */}

            <div className="appointBlk">
              <div className="time_date">{moment().format("DD MMMM YYYY")}</div>
              {appointmentsData.slice(0, 3).map((item, index) => (
                <div className="card_continer" key={index}>
                  <div className="info">
                    <span>{item.appointmentTime}</span>
                    <span>
                      {language === Ilanguages.ARB
                        ? item.departmentNameAr
                        : item.departmentName}
                    </span>
                    <span>
                      {language === Ilanguages.ARB
                        ? item.doctorName_ar
                        : item.doctorName}
                    </span>
                  </div>
                  <button
                    onClick={() => {
                      dispatch(appointmentsCheckinRequest(item.encounterId));
                    }}
                  >
                    {t("Kiosk.checkIn" + language)}
                  </button>
                </div>
              ))}
            </div>
            {/* appointment section ends */}
            <div className="appointments-text" style={{ display: "none" }}>
              <Row className="align-items-center">
                <div className="px-3">
                  <img
                    src={prevAppt}
                    className={
                      "pointer " + (currentPage <= 0 ? "disabled" : "")
                    }
                    alt="prevAppt"
                    onClick={() => {
                      if (currentPage > 0) setCurrentPage(currentPage - 1);
                    }}
                  />
                </div>
                <Col>
                  <p>
                    {t("Kiosk.hi" + language)} {emiratesData ? nameOfuser : ""}
                  </p>
                  <h2>{t("Kiosk.appointments" + language)}</h2>
                  <p>{moment(new Date()).format("DD-MM-YYYY")}</p>
                  <div className="appointments-container">
                    {appointmentsData &&
                      appointmentsData.length > 0 &&
                      appointmentsData
                        .slice(
                          currentPage * pageSize,
                          (currentPage + 1) * pageSize
                        )
                        .map((item, index) => {
                          return (
                            <div className="appointment" key={index}>
                              <div className="appointment-property">
                                <div className="appointment-value">
                                  {language === Ilanguages.ENG
                                    ? item?.patientName
                                    : item?.patientName_ar}
                                </div>
                                <div className="appointment-key">
                                  {t("Kiosk.patientName" + language)}
                                </div>
                              </div>

                              <div className="appointment-property">
                                <div className="appointment-value">
                                  {language === Ilanguages.ENG
                                    ? item?.doctorName
                                    : item?.doctorName_ar}
                                </div>
                                <div className="appointment-key">
                                  {t("Kiosk.doctor" + language)}
                                </div>
                              </div>

                              <div className="appointment-property">
                                <div className="appointment-value">
                                  {language === Ilanguages.ARB
                                    ? item?.departmentNameAr
                                    : item?.departmentName}
                                </div>
                                <div className="appointment-key">
                                  {t("Kiosk.department" + language)}
                                </div>
                              </div>

                              <div className="appointment-property">
                                <div className="appointment-value">
                                  {item.appointmentTime}
                                </div>
                                <div className="appointment-key">
                                  {t("Kiosk.appointmentTime" + language)}
                                </div>
                              </div>

                              <div className="appointment-button">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    dispatch(
                                      appointmentsCheckinRequest(
                                        item.encounterId
                                      )
                                    );
                                  }}
                                >
                                  {t("Kiosk.checkIn" + language)}
                                </button>
                              </div>
                            </div>
                          );
                        })}
                  </div>
                </Col>
                <div className="pl-2 pr-3">
                  <img
                    src={nextAppt}
                    className={
                      "pointer " +
                      (currentPage >= pagesCount - 1 ? "disabled" : "")
                    }
                    alt="nextAppt"
                    onClick={() => {
                      if (currentPage < pagesCount - 1) {
                        setCurrentPage(currentPage + 1);
                      }
                    }}
                  />
                </div>
              </Row>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default React.memo(ThemeOneAppointmentsList);
